import { Container, Typography } from '@mui/material';

const AboutPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom>
        About Street Ratings
      </Typography>
      <br />
      <Typography variant="body1" component="p">
        Hi, I'm <strong>Jack</strong>, an indie developer based in Melbourne, Australia. Street
        Ratings is my very first mobile app, born out of a simple frustration: I wanted a quicker
        way to see <em>real</em> reviews while standing right outside a shop, café or venue.
      </Typography>
      <br />

      <Typography variant="body1" component="p">
        <strong>💡 Why build it?</strong> As a software engineer I've always loved creating things
        that people genuinely enjoy using. When I realised how often friends asked "Is this place
        any good?" the idea clicked: point, scan, get honest feedback in seconds.
      </Typography>
      <br />

      <Typography variant="body1" component="p">
        <strong>⏱ Early-stage stats</strong>, Street Ratings is still in its infancy, so you may
        spot rough edges. Right now the scan accuracy in my own testing is about &nbsp;
        <strong>70 %</strong> and the typical turnaround is <strong>2-4 seconds</strong>. I'm
        pushing updates regularly to sharpen results and trim that response time.
      </Typography>
      <br />

      <Typography variant="body1" component="p">
        🙌 A huge thanks to Google Cloud and Google Places, without these this project wouldn't
        exist. Their generous tooling (and free tier!) make it possible for solo devs like me to
        launch products that once required whole teams.
      </Typography>
      <br />

      <Typography variant="body1" component="p">
        <strong>📬 Say hello!</strong> Got ideas, or bug reports? Email me at&nbsp;{' '}
        <strong>streetratings123[at]gmail[dot]com</strong>&nbsp;and I'll get back to you as quickly
        as possible.
      </Typography>
      <br />

      <Typography variant="body1" component="p">
        Thanks for checking out Street Ratings , I hope it helps you find great spots around town as
        much as it helps me!
      </Typography>
    </Container>
  );
};

export { AboutPage };
